import * as React from 'react';
import {WorkerSelect} from './worker/WorkerSelect';
import {withRouter} from 'react-router-dom';
import {Direction} from '../../models/enums/Direction';

export const SignOut = withRouter(({history}) => {
    return <WorkerSelect direction={Direction.EXIT} history={history}/>;
});
